// extracted by css-extract-rspack-plugin
export default {"blockContainer":"blockContainer-VitoPp","rowContainer":"rowContainer-NZnVNo","label":"label-DPTYoH","value":"value-Vdr0il"};